import React, { useState, useEffect } from "react";
import { Redirect, useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

import TopicEditForm from "~/Components/Elements/Forms/TopicEdit/TopicEditForm";

import { useUser } from "~/Context/userContext";
import MessageBoardTopicContainer from "~/Containers/MessageBoardTopicContainer";

const MessageBoardTopicEditPage = ({ match }) => {
  let history = useHistory();
  const [userLoading, setUserLoading] = useState(true);
  const { state: userState } = useUser();
  const onComplete = () => {
    history.push(`/message-board/topic/${match.params.id}`);
  };
  useEffect(() => {
    setUserLoading(!userState.loaded);
  }, [userState.loaded]);
  return (
    <MessageBoardTopicContainer
      className="TopicEditWrapper"
      topicId={match.params.id}
      render={({ topic, loading, failure }) => {
        if (!loading && !userLoading && (failure || topic.thread_author.dir !== userState.user.dir)) {
          return <Redirect to={`/`} />;
        }
        return (
          <div>
            {(loading && (
              <SkeletonTheme color="#fff" highlightColor="#f3f3f3">
                <Skeleton count={1} />
              </SkeletonTheme>
            )) || (
              <React.Fragment>
                <div id="topic-edit-wrapper">
                  <div className="page-header">
                    <h2>Edit Topic</h2>
                  </div>
                  <TopicEditForm topic={topic} onComplete={onComplete} />
                </div>
              </React.Fragment>
            )}
          </div>
        );
      }}
    />
  );
};

MessageBoardTopicEditPage.propTypes = {
  topic: PropTypes.object,
};

MessageBoardTopicEditPage.defaultProps = {
  topic: {},
};

export default MessageBoardTopicEditPage;
